module.exports = {
  baseAPIDev: "http://localhost:9000/v1",
  baseAPI: "https://api.growcify.com/v1",
};
